import { Resource } from './models';

export interface ResourceState {
  resourceItems: Resource[];
  urlUploadPending: boolean;
  urlUploadError: string | null;
  urlUploadSuccess: boolean;
  pendingResourceIds: string[];
}

export const intialState: ResourceState = {
  resourceItems: [],
  urlUploadPending: false,
  urlUploadError: null,
  urlUploadSuccess: false,
  pendingResourceIds: [],
};
